/**
 * Get a value from an nested object
 *
 * @param {Object}  object Object that we want to query from
 * @param {String} path query path for that object in form of "path.to.object"
 * @param {any} defaultValue default value to be returned if path does not exist
 *
 * @returns {Object} value if found. otherwise, return default value or undefined
 */
export default (object, path, defaultValue) => {
  if (!path) {
    return defaultValue
  }

  const pathArray = path.split('.')

  return pathArray.reduce((prevPath, nextPath) => prevPath?.[nextPath] ?? defaultValue, object)
}
